import analysisBMiddleware from './analysisBefore';
import analysisAMiddleware from './analysisAfter';
import fetchMiddleware from './fetch';

export default function getCoreMiddlewares() {
  return [
    analysisBMiddleware,
    fetchMiddleware(),
    analysisAMiddleware,
  ];
}